<template>
    <div
        class="tags-input"
        tabindex="1"
    >
        <div
            class="item"
            v-for="(item, index) in items"
            :key="index"
        >
            <p>{{ item }}</p>

            <span
                v-if="!readOnly"
                class="remove"
                @click="$emit('remove', item)"
            >
                &times;
            </span>
        </div>

        <input
            type="text"
            @input="$emit('input', $event.target.value)"
            @click="$emit('click')"
            :placeholder="items.length === 0 ? placeholder : ''"
            :maxlength="inputLimit > 0 ? inputLimit : ''"
            @keydown.enter="enterTag($event)"
            :disabled="readOnly"
            :value="value"
        >
    </div>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => []
		},

		placeholder: {
			type: String,
			default: ''
		},

		allowCustom: {
			type: Boolean,
			default: true
		},

		readOnly: {
			type: Boolean,
			default: false
		},

		inputLimit: {
			type: Number,
			default: 0
		},

		value: {
			type: [String, Number]
		}
	},

	methods: {
		enterTag (e) {
			e.preventDefault()

			if (this.allowCustom) {
				this.$emit('enter', e.target.value)
				e.target.value = ''
			} else {
				return false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.tags-input {
    border: 1px solid $default-light;
    border-radius: 3px;
    display: flex;
    flex-flow: row wrap;
    padding: 5px;
    position: relative;
    background-color: #fff;

    &:focus, &:focus-within {
        border-color: $primary;
        outline: none;
    }

    .item {
        display: flex;
        align-items: center;
        background-color: #E7E7EE;
        padding: 2px 5px;
        margin-right: 5px;
        margin-top: 2px;
        margin-bottom: 2px;

        p {
            font-size: 1em;
        }

        .remove {
            cursor: pointer;
            margin-left: 5px;
            font-weight: 600;
            font-size: 16px;
            line-height: 1em;

            &:hover {
                color: #E75546;
            }
        }
    }

    input {
        flex: 1 1 auto;
        border: none;

        &::placeholder {
            color: $default-light;
            font-size: .9em;
        }

        &:disabled {
            background: transparent;
        }

        &:focus &::placeholder { color: $default-light; }
    }
}
</style>
